function clean(s) {
  return String(s == null ? "" : s).replace(/[\r\n]+/g, " ").trim();
}

export function makeCSV(cls) {
  const esc = s => `"${clean(s).replace(/"/g, '""')}"`;
  const header = "﻿url;title;h1;description;keywords_in_title\r\n";
  return header + cls.filter(c => c.meta).map(c => {
    const used = (c.meta.used_keywords || []).join(", ");
    return [esc(c.url), esc(c.meta.title), esc(c.meta.h1 || ""), esc(c.meta.description), esc(used)].join(";");
  }).join("\r\n");
}

export function makeTSV(cls) {
  const header = "url\ttitle\th1\tdescription\tkeywords_in_title\n";
  return header + cls.filter(c => c.meta).map(c =>
    [
      clean(c.url),
      clean(c.meta?.title),
      clean(c.meta?.h1 || ""),
      clean(c.meta?.description),
      (c.meta?.used_keywords || []).join(", "),
    ].join("\t")
  ).join("\n");
}

export function dlFile(content, fn) {
  try {
    const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fn;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (e) {
    const encoded = encodeURIComponent(content);
    window.open("data:text/csv;charset=utf-8," + encoded);
  }
}
